import React, { useEffect, useState, ReactElement, MouseEvent } from "react";
import { UserBoxLink, UserTopBox } from "@/features";
import { queries } from "@/graphql";
import { getRoleTypeNameFromUser } from "@/utils";
import { useUser } from "@/app/providers";
import { useUpdateProfile } from "@/hooks";
import { useLazyQuery } from "@apollo/client/react";

/**
 * Profile component displays user profile menu and handles partner/role initialization.
 */
export const Profile = (): ReactElement => {
  const { user, setUser } = useUser();
  const { updateProfile } = useUpdateProfile();
  const [getPartners] = useLazyQuery(queries.getAllPartners);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const roleType = getRoleTypeNameFromUser(user);

  useEffect(() => {
    if (roleType === "partner" && user?.email && !user?.currentPartnerId) {
      getPartners({
        variables: {
          email: user.email,
        },
      }).then((res: any) => {
        const partnerId = res?.data?.getPartners?.[0]?.id;
        if (partnerId) {
          const variables = {
            currentPartnerId: partnerId,
          };
          setUser((prev: any) => ({
            ...prev,
            ...variables,
          }));
          updateProfile(variables);
        }
      });
    }
  }, [
    getPartners,
    roleType,
    setUser,
    updateProfile,
    user?.email,
    user?.currentPartnerId,
  ]);

  useEffect(() => {
    if (!user?.currentRoleKey && user?.roles?.length) {
      const firstRoleType = user.roles[0].split("-")[0];
      if (firstRoleType === "system" || firstRoleType === "super") {
        const variables = {
          currentRoleKey: user.roles[0],
        };
        setUser((prev: any) => ({
          ...prev,
          ...variables,
        }));
        updateProfile(variables);
      }
    }
  }, [setUser, updateProfile, user?.currentRoleKey, user?.roles]);

  const handleClick = (event: MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <UserBoxLink onClick={handleClick} />
      <UserTopBox anchorEl={anchorEl} onClose={handleClose} />
    </>
  );
};
